export default "__VITE_ASSET__HnA4szdW__"